import { useMemo, useState } from 'react';
import WalletCard from '../../../../../../components/WalletCard/WalletCard';
import './index.scss';

import InvestifyWTAC from '../../../../../../assets/icons/InvestifyWTAC.svg';
import NoData from '../../../../../../components/NoData/NoData';
import { useNavigate, useParams } from 'react-router-dom';

import TransactionDetailsAlt from '../../../../../../components/NewSideSheet/TransactionDetailsAlt/TransactionDetailsAlt';
import useCustomers from '../../../../../../hooks/useCustomers';
import useInvestify from '../../../../../../hooks/useInvestify';
import InvestifyInvestmentList from './InvestifyInvestmentList';
import { Loader } from '@piggytechng/component-library';

const index = () => {
  const [showWalletBalance] = useState(true);

  const params = useParams();
  const navigate = useNavigate();

  const id = params.id as string;

  const { setTransactionsParams, isLoadingInvestmentList, transactionsParams, InvestmentList } = useInvestify();

  const [show, setShow] = useState(false);
  const [trDetails] = useState({});

  const { UserBalances } = useCustomers();

  const walletKey = 'investify';

  const walletCardsData = useMemo(() => {
    return [
      {
        title: 'Investify Balance:',
        balanceKey: UserBalances?.investify ?? 0,
        cardId: 'hm-card',
        image: InvestifyWTAC,
        isActive: true,
        isOpenSideSheet: true,
      },
    ];
  }, [UserBalances]);

  const handleSubmit = (e: any) => {
    e.preventDefault();
  };

  const handleShowTransactionsDetails = (data: any) => {
    if (transactionsParams.category === 'ipo') {
      navigate(`/view-ipo-investment/${id}/${data.investId}`);
      return;
    }
    navigate(`/view-investment/${id}/${data.investId}/${transactionsParams.category}`);
  };

  return (
    <>
      <div className="wallet-investify-page">
        <div className="cards-container flex--2">
          {walletCardsData.map((item: any, i: any) => (
            <WalletCard
              key={i}
              {...item}
              showBalance={showWalletBalance}
              balance={item.balanceKey}
              walletKey={walletKey}
            />
          ))}
        </div>
        <div className="tab-switch flex--2">
          <p
            className={`pointer tab ${transactionsParams.category === 'active' && 'active'}`}
            onClick={() => setTransactionsParams((prev) => ({ ...prev, category: 'active' }))}
          >
            Active Investments
          </p>
          <p
            className={`pointer tab ${transactionsParams.category === 'ipo' && 'active'}`}
            onClick={() => setTransactionsParams((prev) => ({ ...prev, category: 'ipo' }))}
          >
            IPO Investments
          </p>
          <p
            className={`pointer tab ${transactionsParams.category === 'matured' && 'active'}`}
            onClick={() => setTransactionsParams((prev) => ({ ...prev, category: 'matured' }))}
          >
            Matured Investments
          </p>
        </div>
        <div className="wallets-details">
          <div className="customers-filter">
            <div className="input-field">
              <form action="" onSubmit={(e) => handleSubmit(e)}>
                <input type="text" placeholder="Search by Transaction ID, date" />
              </form>
            </div>
            <div className="query-filter">
              <div>
                <svg width="10" height="10" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M0.75 0.75H17.25M6.75 13.25H11.25M3.75 7H14.25"
                    stroke="#1E293B"
                    strokeWidth="1.5"
                    strokeLinecap="square"
                  />
                </svg>
              </div>
              <div>Search</div>
            </div>
            <div className="query-filter">
              <div></div>
              <div>Reset</div>
            </div>
          </div>
        </div>

        {isLoadingInvestmentList ? (
          <div className="page-loader">
            <Loader color="#0F60D6" />
          </div>
        ) : (
          <>
            {InvestmentList && InvestmentList.length > 0 && (
              <div className="flex--3">
                <p className="active-text">
                  {transactionsParams.category === 'active'
                    ? 'Active'
                    : transactionsParams.category === 'ipo'
                      ? 'IPO'
                      : 'Matured '}
                </p>
                <p
                  className="view-all-g investify pointer"
                  onClick={() => navigate(`/view-all-investments/${id}/${transactionsParams.category}`)}
                >
                  View all
                </p>
              </div>
            )}
            {InvestmentList && InvestmentList.length ? (
              <InvestifyInvestmentList items={InvestmentList} onItemClick={handleShowTransactionsDetails} />
            ) : (
              <NoData message={'No transaction at the moment.'} />
            )}
          </>
        )}
      </div>

      <TransactionDetailsAlt
        show={show}
        id={''}
        data={trDetails}
        onClose={() => {
          setShow(false);
        }}
      />
    </>
  );
};

export default index;
